import { DisplayMeasurementProfileDetail } from "@fairfleet/geotab";
import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { RESULTS_LIMIT_DISPLAY_MEASUREMENT_PROFILE_DETAIL } from "@/constants/resultsLimits";

export default function useDisplayMeasurementProfileDetail(profilId: string | undefined) {
  const { geotabClient } = useGeotabClient();
  return useQuery({
    queryKey: ["displayMeassurementProfile", profilId],

    queryFn: ({ signal }): Promise<DisplayMeasurementProfileDetail[]> => {
      if (!profilId) {
        return Promise.resolve([]);
      }
      return geotabClient.call(
        "Get",
        {
          typeName: "DisplayMeasurementProfileDetail",
          search: {
            displayMeasurementProfileSearch: { id: profilId },
          },
          resultsLimit: RESULTS_LIMIT_DISPLAY_MEASUREMENT_PROFILE_DETAIL,
        },
        signal,
      );
    },
  });
}
